<template>
  <transition name="slide-in-top" v-if="scrollY > 100 && !isMobile">
    <div :class="$style['go-top']" @click="goTop" @mouseenter="hover = true" @mouseleave="hover = false">
      <span class="iconfont" :class="{[$style.hover]:hover}">{{hover ? '返回顶部' : '&#xe606;'}}</span>
    </div>
  </transition>
</template>
<script>
import {mapState} from 'vuex'
import scroller from 'vue-scrollto'
export default {
  name: 'go-top',
  data () {
    return {
      scrollY: 0,
      hover: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  mounted () {
    this.listenerScroll()
    window.addEventListener('scroll', this.listenerScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenerScroll)
  },
  methods: {
    /**
     * 监听 scroll
     */
    listenerScroll (event) {
      this.scrollY = window.pageYOffset
    },
    /**
     * 返回顶部
     */
    goTop () {
      scroller.scrollTo('body')
    }
  }
}
</script>

<style lang="scss" module>
@import "../../assets/css/common";
.go-top {
  box-sizing: border-box;
  position: fixed; z-index: 300; left: 50%; bottom: 100px;
  margin-left: 540px;
  @extend %center;
  width: 42px; height: 50px;
  padding: 7px 8px;
  overflow: hidden;
  background: $lightGray;
  color: $gray;
  border-radius: 4px;
  cursor: pointer;
  @extend %transition;

  &:hover {
    color: $gray;
    background: #e8eaee;
  }

  & .hover {
    @include font(12, 400);
  }
}

.slide-in-top-enter-active,
.slide-in-top-leave-active{
  transition: all 0.3s ease;
}
.slide-in-top-enter,
.slide-in-top-leave-to {
  transform: translateY(5px);
  opacity: 0;
}
</style>
